import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import {List} from '@/components/core';


const timerData = [
  { title: '2025.10', content: '明心跨境大模型通过国家大模型服务备案' },
  { title: '2025.6', content: '近2亿元B2轮融资,沂景资本、金蚂投资、国泰君安创新投携手投资,鼎晖投资和柏睿资本持续加注' },
  { title: '2025.1', content: '近2亿元B轮融资,柏睿资本领投,国方创新、狮城资本和鼎晖VGC跟投' },
  { title: '2024.1', content: '入选工信部“2023年大数据产业发展示范名单”' },
  { title: '2023.4', content: '近亿元A+轮投资,鼎晖VGC领投' },
  { title: '2023.3', content: '明心·跨赋3.0系统产品正式发布' },
  { title: '2022.6', content: '自研产业信用数字化系统CMP正式上线' },
  { title: '2021.9', content: '亿元A轮融资,鼎晖VGC、嘉实投资联合领投' },
  { title: '2021.3', content: '天使轮融资,红杉资本' },
  { title: '2020.12', content: '完成种子轮融资' },
  { title: '2020.8', content: '明心数智正式成立' },
]
const timerCfg = {
  data: timerData.map(item => {
    return {
      title: {title: item.title, itemClass: 'item-title'},
      dot: item.content.split(',').map(it => {
        return {
          title: it,
          itemClass: 'it-title'
        }
      }),
    }
  }),
  listClass: 'timer-list'
}

const Pages = props => {
  return (
    <div className="pages-tab-content np">
      <div className="p-part1">
        <div className="pages-title mb-default">企业介绍</div>
        <div className="flex-row wid1200">
          <div className="item-body">
            <div className='mb-default'>明心数智是中国领先的<b>产业级大模型AI应用服务商</b>。公司聚焦于<b>产业出海</b>的核心场景，致力于为跨境出海企业提供<b>“AI+出海”的新一代基础设施与服务</b>，将自主研发的产业大数据分析和应用平台，转化为企业可快速部署应用的AI能力，助力数百万出海企业实现全球业务增长。</div>
            <div className='mb-default'>公司研发团队在<b>人工智能、大数据、物联网应用、数据分析、算法建模</b>等领域实力雄厚。经过多年的技术积累，公司在AI技术与产业智能监测等方向构建了多层次的核心优势，目前已拥有数十项自主知识产权（其中发明专利40余项、软件著作权20余项），为公司的持续创新与高质量发展奠定了坚实的基础。</div>
            <div className='mb-default'>公司与清华智谱团队、清华大学交叉信息研究院、武汉大学联合实验室及中国信通院云计算与大数据研究所等国内顶尖科研机构建立了深度合作关系，通过产学研协同，共同攻坚AI大模型产业应用、隐私计算平台及产业数据资产化等前沿领域。</div>
          </div>
          <img className="item-pic ml64" src ='/images/about/pic.png'/>
        </div>
      </div>
      <div className="p-part2">
        <div className="pages-title mb-default">企业文化</div>
        <div className="wid1200">
          <div className='mb40'>使命：创建共信产业生态 ，AI赋能产业出海</div>
          <div className='mb40'>愿景：中国领先的产业AI应用服务商</div>
          <div className='mb40'>价值观：诚信、利他、团结、担当、拥抱变化、持续创新</div>
        </div>
        <img src="/images/about/about-bg1.png" className='pic'/>
      </div>
      <div className="p-part3">
        <img src="/images/about/about-bg2.png" className='item-pic-ab'/>
        <div className="pages-title mb-default">企业荣誉</div>
        <div className="p3-width">
          <div className='mb-default'>荣获2021年国家科技型中小企业称号</div>
          <div className='mb-default'>荣获2021年中国产业互联网优质服务商奖</div>
          <div className='mb-default'>荣获2022年“高新技术企业”认定</div>
          <div className='mb-default'>荣获“深圳市2022年专精特新中小企业”荣誉称号</div>
          <div className='mb-default'>荣获国家级专精特新“小巨人”企业荣誉称号</div>
          <div className='mb-default'>荣获“中国信息协会数据要素应用创新大赛”决赛一等奖</div>
        </div>
      </div>
      <div className="p-part4">
        <div className="pages-title mb-default">企业大事件</div>
        <List {...timerCfg} />
      </div>
    </div>
  )
}
export default Pages